import styled from 'styled-components';
import H5 from '@bitcoin-portal/bitcoincom-pkg-components/dist/H5';
import Button from '@bitcoin-portal/bitcoincom-pkg-components/dist/Button';
import Paragraph from '@bitcoin-portal/bitcoincom-pkg-components/dist/Paragraph';

export const Wrapper = styled.div`
  width: 100%;
  position: relative;
  max-width: 1024px;
  margin: auto;
  & > div {
    height: 100dvh;
  }
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const StyledH5 = styled(H5)`
  font-size: 18px;
  line-height: 21.48px;
  padding: 0 16px 16px;
  color: #131720;
`;

export const StyledParagraph = styled(Paragraph)`
  font-size: 16px;
  font-weight: 400;
  line-height: 19px;
  color: #6b717e;
`;

export const StyledButton = styled(Button)`
  height: unset;
  padding: unset;

  & > div {
    height: unset;
  }

  & > div > span {
    font-weight: 600;
  }
`;
